export default "__VITE_ASSET__B2UlvKr1__"